import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { IProjectModel, ThemeTypes } from "../../models/SharedModel";
import { text_convert_lower } from "../../helpers/GenericHelpers";
import { useContext } from "react";
import { ThemeContext } from "../../models/ThemeContext";

interface IAddWorkSpaceModalProps {
    addWorkSpaceModal: boolean;
  toggleAddWorkSpaceModal: () => void;
  selectedProject?: IProjectModel | null | undefined;
  workSpaceData?:any;
  selectedWorkSpace:any;
  setSelectedWorkSpace:Function;
  addProjectToWorkSpace:Function;
}


const AddWorkSpaceModal = (props: IAddWorkSpaceModalProps) => {
  const {addWorkSpaceModal, toggleAddWorkSpaceModal, workSpaceData, selectedProject, selectedWorkSpace, setSelectedWorkSpace, addProjectToWorkSpace } = props;

  // states
  const handleChange = (value: string, field: string) => {
    setSelectedWorkSpace((prev:any) => ({
      ...(prev ?? {}),
      [field]: value || "",
    }));
  };

  // display functions
  const displayProjectOptions = () => {
    return workSpaceData?.map((each:any) => {
      return (
        <option value={each?.workspace_id} key={each}>
          {text_convert_lower(each?.workspace_name)}
        </option>
      );
    });
  };

  const { themeName } = useContext(ThemeContext);

  return (
    <Modal
      className={`project-modal project-map-workspace ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
      isOpen={addWorkSpaceModal}
      toggle={toggleAddWorkSpaceModal}
    >
      <ModalHeader toggle={toggleAddWorkSpaceModal}>Map To WorkSpace</ModalHeader>
      <ModalBody>
        <div className="project-form" >
            <Form>
            <div className="input-row">
                <FormGroup className={`project-input type`}>
                    <Label for="eproject-type">WorkSpace Type<span className='required'>*</span></Label>
                    <Input
                    id="project-type"
                    name="project-type"
                    type="select"
                    value={selectedWorkSpace?.workspace_id}
                    onChange={(e) => handleChange(e?.target?.value, "workspace_id")}
                    // disabled={!!selectedProject}
                    >
                    <option value={""}>Select Workspace type</option>
                    {displayProjectOptions()}
                    </Input>
                </FormGroup>
            </div>
            <div className="btns">
                <Button
                    className="submit"
                    onClick={() => addProjectToWorkSpace()}
                >
                    Submit
                </Button>
            </div>
            </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddWorkSpaceModal;
